// src/db/db.js (ou o arquivo que você me mandou)
import sistemaStore from "@/store/sistema";

const versaoDB = 4; // ⬅️ subimos a versão para rodar a migração
const nameDB = sistemaStore.getters.isModeDevelopment()
  ? "nutricao-animal-teste"
  : "nutricao-animal";

/**
 * Verifica se o DB existe sem criá-lo.
 */
export async function existeBancoDados() {
  try {
    if (indexedDB.databases) {
      const dbs = await indexedDB.databases();
      return dbs.some((d) => d.name === nameDB);
    }
    // Fallback (abre e detecta criação)
    const existed = await new Promise((resolve) => {
      let created = false;
      const req = indexedDB.open(nameDB);
      req.onupgradeneeded = () => { created = true; };
      req.onsuccess = (e) => {
        const db = e.target.result;
        db.close();
        if (created) {
          const del = indexedDB.deleteDatabase(nameDB);
          del.onsuccess = () => resolve(false);
          del.onerror = () => resolve(false);
        } else {
          resolve(true);
        }
      };
      req.onerror = () => resolve(false);
    });
    return existed;
  } catch (error) {
    console.error(error);
    return false;
  }
}

/**
 * Abre conexão com o DB. Se não existir, retorna null.
 */
export async function conexaoDB() {
  const dbExist = await existeBancoDados();
  if (!dbExist) return null;

  return new Promise((resolve, reject) => {
    const request = indexedDB.open(nameDB, versaoDB);
    request.onsuccess = (event) => resolve(event.target.result);
    request.onerror = () => reject(request.error);
    request.onblocked = () => {
      console.warn("Abertura do IndexedDB bloqueada por outra aba.");
    };
    // Migração é no iniciarBancoDados()
  });
}

export async function iniciarBancoDados() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(nameDB, versaoDB);

    req.onupgradeneeded = (event) => {
      const db = event.target.result;
      //const tx = event.target.transaction; // versionchange transaction

      const ensureStore = (name, options = { autoIncrement: true }) => {
        if (!db.objectStoreNames.contains(name)) {
          db.createObjectStore(name, options);
        }
      };

      // v1
      if (event.oldVersion < 1) {
        ensureStore("usuarios-relacionados");
        ensureStore("usuario-logado");
        ensureStore("atalhos-iniciais");
        ensureStore("clientes");
        ensureStore("produtos");
        ensureStore("config-pedidos");
        ensureStore("produtos-pendentes");
        ensureStore("pedidos");
        ensureStore("sincronizacoes");
        ensureStore("base");
      }

      // v2
      if (event.oldVersion < 2) {
        ensureStore("insumos");
        ensureStore("pedidos-insumos");
      }

      // v3
      if (event.oldVersion < 3) {
        ensureStore("vt-config");
        ensureStore("vt-visitas");     // será migrada na v4
        ensureStore("vt-produtores");
        ensureStore("vt-sinc");
      }

      // v3
      if (event.oldVersion < 4) {
        ensureStore("vt-docs");
      }

    };

    req.onsuccess = (event) => {
      const db = event.target.result;
      db.onversionchange = () => {
        db.close();
        console.warn("Versão do IndexedDB mudou em outra aba. Conexão fechada.");
      };
      resolve(true);
    };

    req.onerror = () => reject(req.error);
    req.onblocked = () => {
      console.warn("Atualização do IndexedDB bloqueada por outra aba.");
    };
  });
}

export default {
  iniciarBancoDados,
  conexaoDB,
  existeBancoDados,
};
